import React, { Component } from 'react';
import classnames from 'classnames';

class Dropdown extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
    };
    this.dropdownMenu = null;
    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  indexOfKeyInValuesArray(key) {
    let foundIndex = -1;
    this.props.values.forEach((element, index) => {
      if (key === element[0]) {
        foundIndex = index;
      }
    });
    return foundIndex;
  }

  getValueFromValues(key) {
    return this.props.values[this.indexOfKeyInValuesArray(key)][1];
  }

  getKeyFromValues(key) {
    return this.props.values[this.indexOfKeyInValuesArray(key)][0];
  }

  showMenu(event) {
    event.preventDefault();

    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  changeDay(diference) {
    const auxIndex = Math.round(this.indexOfKeyInValuesArray(this.props.selectedKey) + diference);
    if (auxIndex >= 0 && auxIndex < this.props.values.length) {
      const dayKey = this.props.values[auxIndex][0];
      this.props.handleChange(dayKey)
    }
  }

  closeMenu() {
    this.setState({ showMenu: false }, () => {
      document.removeEventListener('click', this.closeMenu);
    });
  }

  renderDropdown() {
    return (
      <div className="dropdown">
        <button className={classnames("button-right", this.indexOfKeyInValuesArray(this.props.selectedKey) === 6 && 'disable')} onClick={() => this.changeDay(+1)}>
          <img src="/img/arrow-right.svg" alt="right" width="10" />
        </button>
        <button className="button-calendar" onClick={this.showMenu} >
          <img src="/img/Calendar.png" alt="Calendar" width="20" />
          <p>{this.getValueFromValues(this.props.selectedKey)}</p>
        </button>
        <button className={classnames("button-left", this.indexOfKeyInValuesArray(this.props.selectedKey) === 0 && 'disable')} onClick={() => this.changeDay(-1)}>
          <img src="/img/arrow-left.svg" alt="left" width="10" />
        </button>
        {
          this.state.showMenu
          && (
            <div
              className="menu"
              ref={(element) => {
                this.dropdownMenu = element;
              }}
            >
              {this.renderDateButtons()}
            </div>
          )
        }
      </div>
    )
  }


  renderDateButtons() {

    return (this.props.values).map((eachDay) => {
      return (
        <button
          key={eachDay[0]}
          onClick={() => this.props.handleChange(eachDay[0])}
          className={classnames('option', eachDay[0] === this.props.selectedKey && 'selected')}
        >
          <p>{eachDay[1]}</p>
        </button>
      )
    });
  }

  render() {
    return (
      this.renderDropdown()
    );
  }
}

export default Dropdown;